import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendSMSToLead = ({ api }: { api: ApiType }) => {
  return useMutation({
    mutationFn: (payload: Parameters<ApiType["smsApi"]["sendSMSToLead"]>[0]) =>
      api.smsApi.sendSMSToLead(payload),
  });
};
